module.exports = __webpack_public_path__ + "static/media/O.e01f0c2a.jpg";